import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", size = "text-xl" }) {
  return (
    <Link to={to} className={`inline-flex items-center font-heading font-extrabold tracking-tight ${size} ${className}`} data-testid="evo-logo">
    </Link>
  );
}

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 text-slate-400">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-amber-500" />
      <span className="text-sm">{label}…</span>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    "Draft": "bg-slate-700/40 text-slate-300 border-slate-600",
    "Estimate Generated": "bg-amber-500/10 text-amber-400 border-amber-500/30",
    "Under Review": "bg-blue-500/10 text-blue-300 border-blue-500/30",
    "Quotation Sent": "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
    "Accepted": "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
    "Declined": "bg-rose-500/10 text-rose-300 border-rose-500/30",
    "Expired": "bg-slate-600/20 text-slate-400 border-slate-600",
    "Converted to Project": "bg-amber-600/20 text-amber-300 border-amber-500/40",
  };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${map[status] || map["Draft"]}`} data-testid="status-badge">
      {status}
    </span>
  );
}
